import React, { PropTypes } from 'react';
import Iframe from '../Iframe/Iframe';

const Video = props => {
  const { value } = props;
  const id = (typeof value === 'string' && value) || (value && value.id);
  const videoSettings = {
    src: 'http://api.svt.se/videoplayer-embed/' + id,
    storlek: (value && value.storlek) || "m",
    height: "56.25%",
    bildtext: value.bildtext,
    foto: value.foto,
    credit: value.credit
  };

  return (
    <Iframe value={videoSettings}/>
  );
};

Video.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object
  ])
};

export default Video;



/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./src/components/Page/PageComponents/Video/Video.js
 **/